import {
    Box,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    MenuItem,
    Stack,
    Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { paymentNewSchema } from 'common/schema';
import FormProvider from 'common/components/form-provider';
import BaseTextField from 'common/components/base-text-field';
import { BaseCheckbox } from 'common/components/base-checkbox-group';
import RequiredLabel from 'common/components/required-label';
import BaseRadioGroupPayment from 'common/components/base-radio-payment';
import bank from 'assets/images/icons/bank.svg';
import vnpay from 'assets/images/icons/vnpay.svg';
import credit from 'assets/images/icons/list-credit.svg';
import momo from 'assets/images/icons/momo.svg';
import { BaseSelectField } from 'common/components/base-select-field';
import { handleError } from 'utils/helpers';
import {
    CheckPricePayment,
    CreatePayment,
    listPlanPayment,
} from 'services/payment.service';
import numeral from 'numeral';
import qrCode from 'assets/images/qr_code.svg';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import WarningIcon from '@mui/icons-material/Warning';
import paymentSuccess from 'assets/images/payment-successful.svg';
import paymentError from 'assets/images/payment-error.svg';
import { toast } from 'react-toastify';
import { useAppSelector } from 'common/hook';
import Footer from './footer';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import BaseDialog from 'common/components/base-dialog';
import { CopyToClipboard } from 'react-copy-to-clipboard';

const ServicePackagePayment: React.FC = () => {
    const { search } = useLocation();
    const params = new URLSearchParams(search);

    const planType = params.get('planType') || '';
    const priceType = params.get('priceType') || '';

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [copied, setCopied] = useState(false);
    const [searchParams] = useSearchParams();
    const transactionStatus = searchParams.get('vnp_TransactionStatus');
    const [openModalPaymentSuccess, setOpenModalPaymentSuccess] =
        useState(false);

    useEffect(() => {
        if (transactionStatus) {
            setOpenModalPaymentSuccess(true);
        }
    }, [transactionStatus]);
    const navigate = useNavigate();
    const userInfo = useAppSelector((state) => state.user);
    const methods = useForm({
        resolver: yupResolver(paymentNewSchema),
        defaultValues: {
            email: '',
            fullName: '',
            phoneNumber: '',
            exportInvoice: false,
            companyName: '',
            paymentMethod: 'bank_transfer',
            servicePackage: planType,
            month: priceType,
            address: '',
            invoiceEmail: '',
            taxCode: '',
        },
    });
    useEffect(() => {
        const rawData = localStorage.getItem('formDataBeforeRedirect');
        const currentPlan = localStorage.getItem('currentPlan');

        let parsedData = null;
        let currentPlanData = null;

        try {
            parsedData = rawData ? JSON.parse(rawData) : null;
            currentPlanData = currentPlan ? JSON.parse(currentPlan) : null;
        } catch (err) {
            console.error('Lỗi parse JSON:', err);
        }

        if (
            parsedData &&
            (transactionStatus === '00' || transactionStatus === '01')
        ) {
            if (!parsedData.exportInvoice) {
                parsedData.taxCode = '';
                parsedData.companyName = '';
                parsedData.address = '';
                parsedData.invoiceEmail = '';
            }

            methods.reset(parsedData);
            setCurrentPlan(currentPlanData);
            setOpenModalPaymentSuccess(true);
        }
    }, [transactionStatus, methods]);

    const [openModalTransferBank, setOpenModalTransferBank] =
        React.useState(false);
    const [openModalConfirmCancelPayment, setOpenModalConfirmCancelPayment] =
        React.useState(false);
    const [openModalConfirmTransferBank, setOpenModalConfirmTransferBank] =
        React.useState(false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onSubmit = async (data: any) => {
        if (data.paymentMethod === 'bank_transfer') {
            setOpenModalTransferBank(true);
            return;
        } else if (data.paymentMethod === 'vnpay') {
            const findPlan = listPlan.find(
                (item) =>
                    item.plan_type === upgradeService &&
                    item.price_type === month
            );
            const payload = {
                payment: {
                    product_type: 'Plan',
                    product_id: findPlan?.id,
                    client_id: userInfo.id,
                    client_company_name: methods.getValues('companyName'),
                    client_tax_number: methods.getValues('taxCode'),
                    client_company_address: methods.getValues('address'),
                    client_name: methods.getValues('fullName'),
                    client_phone: methods.getValues('phoneNumber'),
                    client_email: methods.getValues('email'),
                    client_invoiceEmail: methods.getValues('invoiceEmail'),
                },
            };
            if (!exportInvoice) {
                delete payload.payment.client_company_name;
                delete payload.payment.client_company_address;
                delete payload.payment.client_tax_number;
                delete payload.payment.client_invoiceEmail;
            }
            try {
                const response = await CreatePayment(payload);
                if (response.success) {
                    const responseAttributes = response.data.payment.attributes;
                    if (responseAttributes) {
                        localStorage.setItem(
                            'formDataBeforeRedirect',
                            JSON.stringify(data)
                        );
                        window.open(responseAttributes.url_payment, '_blank');
                        localStorage.setItem(
                            'urlCallback',
                            `/admin/service-package-payment`
                        );
                    }
                } else {
                    toast.error(response.message);
                }
            } catch (error) {
                handleError(error);
            }
        }
    };
    const exportInvoice = methods.watch('exportInvoice');

    const [listPlan, setListPlan] = React.useState<
        {
            id: number;
            plan_type: string;
            price_type: string;
            price: number;
        }[]
    >([]);
    const month = methods.watch('month');
    const upgradeService = methods.watch('servicePackage');

    const convertTime = (value: string) => {
        if (!value) return;
        if (value === 'month') {
            return 'tháng';
        } else {
            return 'năm';
        }
    };
    const convertTextPlan = (value: string) => {
        if (!value) return;
        if (value === 'premier') {
            return 'Cao cấp';
        } else if (value === 'advance') {
            return 'Nâng cao';
        } else if (value === 'standard') {
            return 'Tiêu chuẩn';
        } else {
            return '';
        }
    };

    const handlePaymentBankTransfer = async () => {
        const findPlan = listPlan.find(
            (item) =>
                item.plan_type === upgradeService && item.price_type === month
        );
        const payload = {
            payment: {
                product_type: 'Plan',
                product_id: findPlan?.id,
                client_id: userInfo.id,
                client_company_name: methods.getValues('companyName'),
                client_tax_number: methods.getValues('taxCode'),
                client_company_address: methods.getValues('address'),
                client_name: methods.getValues('fullName'),
                client_phone: methods.getValues('phoneNumber'),
                client_email: methods.getValues('email'),
                client_invoiceEmail: methods.getValues('invoiceEmail'),
                payment_method: 'bank_transfer',
            },
        };
        if (!exportInvoice) {
            delete payload.payment.client_company_name;
            delete payload.payment.client_company_address;
            delete payload.payment.client_tax_number;
            delete payload.payment.client_invoiceEmail;
        }
        try {
            const response = await CreatePayment(payload);
            if (response.success) {
                setOpenModalConfirmTransferBank(true);
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            handleError(error);
        }
    };
    React.useEffect(() => {
        const fetchListPlan = async () => {
            try {
                const response = await listPlanPayment({});
                if (response.success) {
                    setListPlan(
                        response.data.plans.map(
                            (item: {
                                attributes: any; // eslint-disable-line @typescript-eslint/no-explicit-any
                            }) => item.attributes
                        )
                    );
                }
            } catch (error) {
                handleError(error);
            }
        };

        fetchListPlan();
    }, []);
    const [currentPlan, setCurrentPlan] = React.useState<{
        id: number;
        plan_type: string;
        price_type: string;
        price: number;
        discount?: number;
        price_unit: number;
        tax: number;
    } | null>(null);
    React.useEffect(() => {
        const checkPrice = async () => {
            if (month && upgradeService && listPlan.length > 0) {
                const findPlan = listPlan.find(
                    (item) =>
                        item.plan_type === upgradeService &&
                        item.price_type === month
                );
                try {
                    const payload = {
                        payment: {
                            product_type: 'Plan',
                            product_id: findPlan?.id,
                            client_id: userInfo.id,
                        },
                    };
                    const response = await CheckPricePayment(payload);
                    if (response.success) {
                        const responseAttributes =
                            response.data.payment.attributes;
                        const obj = {
                            id: responseAttributes.id,
                            plan_type: responseAttributes.product_id,
                            price_type: responseAttributes.price_type,
                            price: responseAttributes.total_price,
                            discount: responseAttributes.discount,
                            price_unit: responseAttributes.price_unit,
                            tax: responseAttributes.tax,
                        };
                        setCurrentPlan(obj);
                        localStorage.setItem(
                            'currentPlan',
                            JSON.stringify(obj)
                        );
                    }
                } catch (error) {
                    handleError(error);
                }
                // setCurrentPlan({});
            }
        };
        checkPrice();
    }, [month, upgradeService, userInfo.id, listPlan]);

    return (
        <Box>
            <Stack direction="row" spacing={2} alignItems="center" mt={4}>
                <Button
                    variant="outlined"
                    onClick={() => navigate(-1)}
                    sx={{
                        minWidth: 'auto',
                        width: 40,
                        height: 40,
                        padding: 0,
                        borderRadius: 3,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '1px solid #D8DADC',
                        '&:hover': {
                            borderColor: '#000',
                        },
                    }}
                >
                    <ArrowBackIosNewIcon
                        fontSize="small"
                        sx={{ color: '#000' }}
                    />
                </Button>
                <Typography
                    variant="body1"
                    component="h3"
                    sx={{
                        color: '#000',
                    }}
                >
                    Về bảng giá
                </Typography>
            </Stack>
            <FormProvider
                methods={methods}
                onSubmit={methods.handleSubmit(onSubmit)}
            >
                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} textAlign={'center'}>
                        <Typography
                            variant="h4"
                            component="h1"
                            sx={{
                                fontWeight: 'bold',
                                color: '#333',
                            }}
                        >
                            Thanh toán gói dịch vụ
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography
                            variant="h5"
                            component="h1"
                            sx={{
                                fontWeight: 'bold',
                                color: '#333',
                            }}
                        >
                            Thông tin người mua
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6} textAlign={'left'}>
                        <Stack spacing={2} mt={2} direction={'row'}>
                            <BaseTextField
                                name="fullName"
                                size="small"
                                fullWidth
                                placeholder="Họ và tên"
                            />
                            <BaseTextField
                                name="phoneNumber"
                                size="small"
                                fullWidth
                                placeholder="Số điện thoại"
                            />
                        </Stack>
                        <Stack spacing={2} mt={2} direction={'row'}>
                            <BaseTextField
                                name="email"
                                size="small"
                                fullWidth
                                placeholder="Email"
                            />
                        </Stack>
                        <Stack mt={2} mb={2}>
                            <BaseCheckbox
                                name="exportInvoice"
                                label={'Xuất hóa đơn'}
                            />
                        </Stack>
                        {exportInvoice && (
                            <Box mb={2}>
                                <Stack spacing={2} mt={2}>
                                    <RequiredLabel
                                        sx={{ fontSize: '1rem' }}
                                        label="Tên công ty"
                                        required={true}
                                    />
                                    <BaseTextField
                                        sx={{ mt: '8px !important' }}
                                        name="companyName"
                                        size="small"
                                        fullWidth
                                        placeholder="Tối thiểu 2 ký tự"
                                    />
                                </Stack>
                                <Stack spacing={2} mt={2}>
                                    <RequiredLabel
                                        sx={{ fontSize: '1rem' }}
                                        label="Địa chỉ"
                                        required={true}
                                    />
                                    <BaseTextField
                                        sx={{ mt: '8px !important' }}
                                        name="address"
                                        size="small"
                                        fullWidth
                                        placeholder="Địa chỉ"
                                    />
                                </Stack>
                                <Stack spacing={2} mt={2}>
                                    <RequiredLabel
                                        sx={{ fontSize: '1rem' }}
                                        label="Mã số thuế"
                                        required={true}
                                    />
                                    <BaseTextField
                                        sx={{ mt: '8px !important' }}
                                        name="taxCode"
                                        size="small"
                                        fullWidth
                                        placeholder="Mã số thuế"
                                    />
                                </Stack>
                                <Stack spacing={2} mt={2}>
                                    <RequiredLabel
                                        sx={{ fontSize: '1rem' }}
                                        label="Email nhận hóa đơn điện tử"
                                        required={true}
                                    />
                                    <BaseTextField
                                        sx={{ mt: '8px !important' }}
                                        name="invoiceEmail"
                                        size="small"
                                        fullWidth
                                        placeholder="Email"
                                    />
                                </Stack>
                            </Box>
                        )}
                        <Typography
                            variant="h5"
                            component="h1"
                            sx={{
                                fontWeight: 'bold',
                                color: '#333',
                                mb: 2,
                            }}
                        >
                            Hình thức thanh toán
                        </Typography>

                        <BaseRadioGroupPayment
                            name={'paymentMethod'}
                            options={[
                                {
                                    label: 'Chuyển khoản ngân hàng',
                                    value: 'bank_transfer',
                                    image: bank,
                                },
                                {
                                    label: 'Thanh toán qua VNPAY',
                                    value: 'vnpay',
                                    image: vnpay,
                                },
                                {
                                    label: 'Thanh toán bằng ví MoMo',
                                    value: 'momo',
                                    image: momo,
                                },
                                {
                                    label: 'Thẻ tín dụng',
                                    value: 'credit_card',
                                    image: credit,
                                },
                            ]}
                            sx={{
                                '& .MuiFormControlLabel-root': {
                                    width: '100%',
                                    padding: 2,
                                    border: '1px solid #ECECEC',
                                    borderRadius: '12px',
                                    mb: 2,
                                    ml: 0,
                                },
                                '& .MuiFormControlLabel-root.selected': {
                                    border: '2px solid var(--color-primary)',
                                },
                            }}
                        />

                        <Button
                            type="submit"
                            variant="contained"
                            fullWidth
                            sx={{
                                mt: 2,
                                textTransform: 'none',
                                fontWeight: 'bold',
                                minHeight: '56px',
                                borderRadius: '8px',
                            }}
                        >
                            Thanh toán
                        </Button>
                        <p>
                            Bằng việc đồng ý thanh toán, Quý khách xác nhận đã
                            đọc, hiểu và đồng ý với{' '}
                            <a
                                href="https://admin.surveytrue.com/truesurvey_landingpage/terms_and_conditions.html"
                                style={{
                                    color: 'var(--color-primary)',
                                    textDecoration: 'none',
                                }}
                            >
                                Quy định sử dụng dịch vụ{' '}
                            </a>
                            và{' '}
                            <a
                                href="https://admin.surveytrue.com/truesurvey_landingpage/privacy_policy.html"
                                style={{
                                    color: 'var(--color-primary)',
                                    textDecoration: 'none',
                                }}
                            >
                                Chính sách riêng tư{' '}
                            </a>
                            của SurveyTrue.
                        </p>
                    </Grid>
                    <Grid item xs={12} md={1}></Grid>
                    <Grid item xs={12} md={5}>
                        <Box
                            sx={{
                                backgroundColor: '#F0F0F0',
                                borderRadius: '16px',
                                padding: '24px 32px',
                            }}
                        >
                            <Stack spacing={2}>
                                <RequiredLabel
                                    sx={{
                                        fontSize: '1rem',
                                        fontWeight: 'bold',
                                    }}
                                    label="Loại gói"
                                    required={true}
                                />
                                <BaseSelectField
                                    sx={{
                                        mt: '8px !important',
                                        '& .MuiInputBase-root': {
                                            backgroundColor: '#F3ECFF',
                                            borderRadius: '8px',
                                        },
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#7B61FF',
                                        },
                                        '& .MuiSvgIcon-root': {
                                            color: '#7B61FF',
                                        },
                                    }}
                                    name="servicePackage"
                                    size="small"
                                    fullWidth
                                >
                                    <MenuItem value={'premier'}>
                                        Gói cao cấp
                                    </MenuItem>
                                    <MenuItem value={'advance'}>
                                        Gói nâng cao
                                    </MenuItem>
                                    <MenuItem value={'standard'}>
                                        Gói tiêu chuẩn
                                    </MenuItem>
                                    <MenuItem value={'basic'}>
                                        Gói cơ bản
                                    </MenuItem>
                                </BaseSelectField>
                            </Stack>
                            <Stack spacing={2} mt={2}>
                                <RequiredLabel
                                    sx={{
                                        fontSize: '1rem',
                                        fontWeight: 'bold',
                                    }}
                                    label="Thời hạn"
                                    required={true}
                                />
                                <BaseSelectField
                                    sx={{
                                        mt: '8px !important',
                                        '& .MuiInputBase-root': {
                                            backgroundColor: '#F3ECFF',
                                            borderRadius: '8px',
                                        },
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#7B61FF',
                                        },
                                        '& .MuiSvgIcon-root': {
                                            color: '#7B61FF',
                                        },
                                    }}
                                    name="month"
                                    size="small"
                                    fullWidth
                                >
                                    <MenuItem value="month">1 tháng</MenuItem>
                                    <MenuItem value="year">12 tháng</MenuItem>
                                </BaseSelectField>
                            </Stack>
                            <Divider
                                style={{
                                    marginTop: '32px',
                                    marginBottom: '32px',
                                }}
                            ></Divider>
                            <Box>
                                <Typography
                                    sx={{
                                        fontWeight: 'bold',
                                        color: '#333',
                                        mt: 2,
                                    }}
                                >
                                    Thông tin đơn hàng
                                </Typography>
                                <Box
                                    display="flex"
                                    flexDirection="row"
                                    justifyContent="space-between"
                                    width="100%"
                                    mt={2}
                                >
                                    <Box>Tên gói</Box>
                                    <Box>
                                        {methods.watch('servicePackage') && (
                                            <>
                                                {methods.watch('servicePackage')
                                                    ? convertTextPlan(
                                                          methods.watch(
                                                              'servicePackage'
                                                          )
                                                      )
                                                    : ''}
                                            </>
                                        )}
                                    </Box>
                                </Box>

                                <Box
                                    display="flex"
                                    flexDirection="row"
                                    justifyContent="space-between"
                                    width="100%"
                                    mt={2}
                                >
                                    <Box>Thời hạn</Box>
                                    <Box>
                                        {methods.watch('month') && (
                                            <>
                                                1{' '}
                                                {methods.watch('month')
                                                    ? convertTime(
                                                          methods.watch('month')
                                                      )
                                                    : ''}
                                            </>
                                        )}
                                    </Box>
                                </Box>
                            </Box>
                            <Divider
                                style={{
                                    marginTop: '32px',
                                    marginBottom: '32px',
                                }}
                            ></Divider>
                            <Box>
                                <Typography
                                    sx={{
                                        fontWeight: 'bold',
                                        color: '#333',
                                        mt: 2,
                                    }}
                                >
                                    Thông tin thanh toán
                                </Typography>
                                <Box
                                    display="flex"
                                    flexDirection="row"
                                    justifyContent="space-between"
                                    width="100%"
                                    mt={2}
                                >
                                    <Box>Giá gói</Box>
                                    <Box>
                                        {currentPlan?.price_unit
                                            ? 'đ' +
                                              numeral(
                                                  currentPlan?.price_unit
                                              ).format()
                                            : 'đ0'}
                                    </Box>
                                </Box>

                                <Box
                                    display="flex"
                                    flexDirection="row"
                                    justifyContent="space-between"
                                    width="100%"
                                    mt={2}
                                >
                                    <Box>Chiết khấu</Box>
                                    <Box color={'var(--color-primary)'}>
                                        {currentPlan?.discount
                                            ? 'đ' +
                                              numeral(
                                                  currentPlan?.discount
                                              ).format()
                                            : 'đ0'}
                                    </Box>
                                </Box>
                                <Box
                                    display="flex"
                                    flexDirection="row"
                                    justifyContent="space-between"
                                    width="100%"
                                    mt={2}
                                >
                                    <Box>VAT (10%)</Box>
                                    <Box>
                                        {currentPlan?.tax
                                            ? 'đ' +
                                              numeral(currentPlan?.tax).format()
                                            : 'đ0'}
                                    </Box>
                                </Box>
                            </Box>
                            <Divider
                                style={{
                                    marginTop: '32px',
                                    marginBottom: '32px',
                                }}
                            ></Divider>
                            <Box>
                                <Box
                                    display="flex"
                                    flexDirection="row"
                                    justifyContent="space-between"
                                    width="100%"
                                    mt={2}
                                >
                                    <Box>
                                        <Typography sx={{ fontWeight: 'bold' }}>
                                            Tổng thanh toán
                                        </Typography>
                                    </Box>
                                    <Box>
                                        {currentPlan?.price
                                            ? 'đ' +
                                              numeral(
                                                  currentPlan?.price
                                              ).format()
                                            : 'đ0'}
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </FormProvider>
            <Dialog
                open={openModalTransferBank}
                onClose={() => setOpenModalTransferBank(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    <Box
                        sx={{
                            padding: '16px 0px',
                            color: '#000',
                            fontWeight: 'bold',
                        }}
                    >
                        Chuyển khoản ngân hàng
                    </Box>
                    <Divider style={{ border: '1px solid #B0B0B0' }} />
                </DialogTitle>

                <DialogContent sx={{ textAlign: 'center' }}>
                    <img src={qrCode} alt="Bank Transfer" />
                    <Box
                        display={'flex'}
                        flexDirection="row"
                        justifyContent="space-between"
                        alignItems="center"
                        mt={2}
                        gap={3}
                    >
                        <Typography sx={{ fontWeight: 'bold', color: '#333' }}>
                            Ngân hàng:
                        </Typography>
                        <Typography sx={{ textAlign: 'right' }}>
                            Techcombank - CN Hà Nội
                        </Typography>
                    </Box>
                    <Box
                        display={'flex'}
                        flexDirection="row"
                        justifyContent="space-between"
                        alignItems="center"
                        mt={2}
                        gap={3}
                    >
                        <Typography sx={{ fontWeight: 'bold', color: '#333' }}>
                            Chủ tài khoản:
                        </Typography>
                        <Typography sx={{ textAlign: 'right' }}>
                            CT TNHH KHAO SAT THAT VIETNAM
                        </Typography>
                    </Box>
                    <Box
                        display={'flex'}
                        flexDirection="row"
                        justifyContent="space-between"
                        alignItems="center"
                        mt={2}
                        gap={3}
                    >
                        <Typography sx={{ fontWeight: 'bold', color: '#333' }}>
                            Số tài khoản:
                        </Typography>
                        <Typography
                            sx={{
                                textAlign: 'right',
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <CopyToClipboard
                                text={'22668879'}
                                onCopy={() => {
                                    setCopied(true);
                                    toast.success(
                                        'Số tài khoản đã được sao chép!'
                                    );
                                }}
                            >
                                <IconButton>
                                    <ContentCopyIcon />
                                </IconButton>
                            </CopyToClipboard>
                            22668879
                        </Typography>
                    </Box>
                    <Divider
                        sx={{ border: '1px solid #B0B0B0', mt: 2, mb: 2 }}
                    />
                    <Box
                        display={'flex'}
                        flexDirection="row"
                        justifyContent="space-between"
                        alignItems="center"
                        mt={2}
                        gap={3}
                    >
                        <Typography sx={{ fontWeight: 'bold', color: '#333' }}>
                            Số tiền cần chuyển:
                        </Typography>
                        <Typography sx={{ textAlign: 'right' }}>
                            đ375.000
                        </Typography>
                    </Box>
                    <Box
                        display={'flex'}
                        flexDirection="row"
                        justifyContent="space-between"
                        alignItems="center"
                        mt={2}
                        gap={3}
                    >
                        <Typography sx={{ fontWeight: 'bold', color: '#333' }}>
                            Nội dung chuyển khoản:
                        </Typography>
                        <Typography
                            sx={{
                                textAlign: 'right',
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <CopyToClipboard
                                text={'ST000001'}
                                onCopy={() => {
                                    setCopied(true);
                                    toast.success(
                                        'Nội dung chuyển khoản đã được sao chép!'
                                    );
                                }}
                            >
                                <IconButton>
                                    <ContentCopyIcon />
                                </IconButton>
                            </CopyToClipboard>
                            ST000001
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            backgroundColor: '#FAEBFF',
                            display: 'flex',
                            alignItems: 'center',
                            padding: '16px',
                            gap: 2,
                            borderRadius: '10px',
                        }}
                    >
                        <WarningIcon sx={{ color: 'var(--color-primary)' }} />
                        <Typography
                            sx={{
                                fontSize: '12px',
                                textAlign: 'left',
                            }}
                        >
                            Để được ghi nhận thanh toán tự động, vui lòng nhập
                            chính xác nội dung chuyển khoản và số tiền cần
                            chuyển.
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            mt: 2,
                            display: 'flex',
                            justifyContent: 'center',
                            gap: 2,
                        }}
                    >
                        <Button
                            onClick={() =>
                                setOpenModalConfirmCancelPayment(true)
                            }
                            sx={{
                                color: '#666666',
                                fontSize: '16px',
                                textTransform: 'none',
                                '&:hover': {
                                    backgroundColor: 'transparent',
                                },
                            }}
                            variant="text"
                        >
                            Hủy đơn hàng
                        </Button>
                        <Button
                            onClick={() => {
                                handlePaymentBankTransfer();
                            }}
                            variant="contained"
                            sx={{
                                textTransform: 'none',
                                fontWeight: 'bold',
                                fontSize: '16px',
                            }}
                        >
                            Tôi đã chuyển khoản
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>
            <Dialog
                open={openModalConfirmCancelPayment}
                onClose={() => setOpenModalConfirmCancelPayment(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    <Box
                        sx={{
                            padding: '16px 0px',
                            color: '#000',
                            fontWeight: 'bold',
                        }}
                    >
                        Quý khách lưu ý
                    </Box>
                    <Divider style={{ border: '1px solid #B0B0B0' }} />
                </DialogTitle>

                <DialogContent sx={{ textAlign: 'center' }}>
                    <Box
                        sx={{
                            mb: 2,
                            color: '#000',
                        }}
                    >
                        Đơn hàng đang trong quá trình thanh toán, bạn có chắc
                        chắn muốn hủy đơn hàng này không?
                    </Box>
                    <Box
                        sx={{
                            backgroundColor: '#FAEBFF',
                            display: 'flex',
                            alignItems: 'center',
                            padding: '16px',
                            gap: 2,
                            borderRadius: '10px',
                        }}
                    >
                        <WarningIcon sx={{ color: 'var(--color-primary)' }} />
                        <Typography
                            sx={{
                                fontSize: '12px',
                                textAlign: 'left',
                                color: '#000',
                            }}
                        >
                            Trường hợp đã thanh toán nhưng đơn hàng chưa được
                            kích hoạt, vui lòng liên hệ qua hotline (+84)
                            902.598.228 để được hỗ trợ.
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            mt: 2,
                            display: 'flex',
                            justifyContent: 'center',
                            gap: 2,
                        }}
                    >
                        <Button
                            onClick={() => {
                                setOpenModalConfirmCancelPayment(false);
                                setOpenModalTransferBank(false);
                            }}
                            sx={{
                                color: '#666666',
                                fontSize: '16px',
                                textTransform: 'none',
                                '&:hover': {
                                    backgroundColor: 'transparent',
                                },
                            }}
                            variant="text"
                        >
                            Hủy đơn hàng
                        </Button>
                        <Button
                            onClick={() =>
                                setOpenModalConfirmCancelPayment(false)
                            }
                            variant="contained"
                            sx={{
                                textTransform: 'none',
                                fontWeight: 'bold',
                                fontSize: '16px',
                            }}
                        >
                            Tiếp tục thanh toán
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>
            <Dialog
                open={openModalConfirmTransferBank}
                onClose={() => {
                    setOpenModalConfirmTransferBank(false);
                    navigate('/admin/overview');
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent sx={{ textAlign: 'center' }}>
                    <img src={paymentSuccess} alt="Payment Success" />
                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: 'bold',
                            mb: 2,
                        }}
                    >
                        Xác nhận thanh toán
                    </Typography>
                    <Box
                        sx={{
                            mb: 2,
                            color: '#000',
                        }}
                    >
                        Hệ thống sẽ xác nhận và sẽ phản hồi lại quý khách qua
                        email {methods.getValues('email')} trong 24h tới.
                    </Box>
                    <Box
                        sx={{
                            backgroundColor: '#FAEBFF',
                            display: 'flex',
                            alignItems: 'center',
                            padding: '16px',
                            gap: 2,
                            borderRadius: '10px',
                        }}
                    >
                        <WarningIcon sx={{ color: 'var(--color-primary)' }} />
                        <Typography
                            sx={{
                                fontSize: '12px',
                                textAlign: 'left',
                                color: '#000',
                            }}
                        >
                            Trường hợp đã thanh toán nhưng đơn hàng chưa được
                            kích hoạt, vui lòng liên hệ qua hotline (+84)
                            902.598.228 để được hỗ trợ.
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            mt: 2,
                            display: 'flex',
                            justifyContent: 'center',
                            gap: 2,
                        }}
                    >
                        <Button
                            onClick={() => {
                                setOpenModalConfirmTransferBank(false);
                                setOpenModalTransferBank(false);
                                navigate('/admin/overview');
                            }}
                            variant="contained"
                            sx={{
                                textTransform: 'none',
                                fontWeight: 'bold',
                                fontSize: '16px',
                            }}
                        >
                            Trang chủ
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>
            <BaseDialog
                open={openModalPaymentSuccess}
                sxContent={{
                    padding: '24px 32px',
                }}
            >
                <Box
                    sx={{
                        textAlign: 'center',
                    }}
                >
                    <img
                        src={
                            transactionStatus === '00'
                                ? paymentSuccess
                                : paymentError
                        }
                        alt="img"
                        width={160}
                    />
                    <h3 style={{ color: '#333' }}>
                        {transactionStatus === '00'
                            ? 'Thanh toán thành công'
                            : 'Thanh toán thất bại'}
                    </h3>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: 2,
                        }}
                    >
                        <Button
                            onClick={() => navigate('/admin/overview')}
                            variant="outlined"
                            sx={{
                                textTransform: 'none',
                                fontWeight: 'bold',
                                fontSize: '16px',
                                color: '#666666',
                                border: '1px solid #666',
                                ':hover': {
                                    color: '#666666',
                                    border: '1px solid #666',
                                },
                            }}
                        >
                            Trang chủ
                        </Button>
                        <Button
                            onClick={() => {
                                if (transactionStatus === '00') {
                                    navigate('/admin/payment');
                                } else {
                                    setOpenModalPaymentSuccess(false);
                                    methods.handleSubmit(onSubmit)();
                                }
                            }}
                            variant="contained"
                            sx={{
                                textTransform: 'none',
                                fontWeight: 'bold',
                                fontSize: '16px',
                            }}
                        >
                            {transactionStatus === '00'
                                ? 'Kiểm tra đơn hàng'
                                : 'Tiếp tục thanh toán'}
                        </Button>
                    </Box>
                </Box>
            </BaseDialog>
            <Footer />
        </Box>
    );
};
export default ServicePackagePayment;
